import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'g-columnPlainText',
	templateUrl: './columnPlainText.component.html',
})
export class ColumnPlainTextComponent implements OnInit {
	constructor() { }

	@Input() data: any;
	@Input() isInActive: any = false;
	@Input() isEditing: boolean = false;
	@Input() isPreCrm: boolean = false;

	ngOnInit() {
	}
}
